import { Slider } from "@mui/material";
import { useTranslations } from "use-intl";

import { CurrencyInput } from "@/components/Inputs/CurrencyInput";
import { formatCurrency } from "@/utils/currency";

type Props = {
  min: number;
  max: number;
  value: [number, number];
  onChange: (value: [number, number]) => void;
  scale?: (value: number) => number;
  descale?: (value: number) => number;
};

export const PriceRangeSlider = ({
  min,
  max,
  value,
  onChange,
  scale,
  descale,
  ...props
}: Props) => {
  const t = useTranslations();

  const scaledMin = scale ? scale(min) : min;
  const scaledMax = scale ? scale(max) : max;
  const scaledCurrentMin = scale ? scale(value[0]) : value[0];
  const scaledCurrentMax = scale ? scale(value[1]) : value[1];

  return (
    <>
      <div className="mx-2">
        <Slider
          {...props}
          min={min}
          max={max}
          onChange={(event, newValue) => {
            onChange(newValue as [number, number]);
          }}
          value={value}
          valueLabelFormat={(value) => formatCurrency(value)}
          valueLabelDisplay="auto"
          scale={scale}
        />
      </div>

      <div className="flex gap-6">
        <CurrencyInput
          min={scaledMin}
          max={scaledCurrentMax}
          label={t("minPrice")}
          value={scaledCurrentMin}
          onChange={(newMin) => {
            const minValue = descale ? descale(newMin) : newMin;
            const maxValue = value[1];
            onChange([minValue, maxValue]);
          }}
        />

        <CurrencyInput
          min={scaledCurrentMin}
          max={scaledMax}
          label={t("maxPrice")}
          value={scaledCurrentMax}
          onChange={(newMax) => {
            const minValue = value[0];
            const maxValue = descale ? descale(newMax) : newMax;
            onChange([minValue, maxValue]);
          }}
        />
      </div>
    </>
  );
};
